import { IPrice, IPriceData } from "./price.type";

export class Price implements IPrice {
    cprcode: number;
    brcode: number;
    price: number;
    lastPrice: number;

    constructor(data: IPriceData) {
        this.cprcode = data.cprcode
        this.brcode = data.brcode
        this.price = data.price
        this.lastPrice = data.lastPrice
    }
    data(): IPriceData {
        return Object.assign({}, this)
    }

}